<!-- Hero Section -->
<section class="hero-section" id="home">

  <!-- Top Navigation Bar -->
  <div class="top-nav">
    <!-- Logo on the left -->
    <div class="logo-container d-flex flex-column gap-2" (click)="navigateToHome()">
      
      <div class="logo-container" (click)="navigateToHome()">
      <img src="../../../../../assets/images/logo-t.png" alt="HPS Life Logo" class="logo-img">
    </div>


      <!-- <div>
      <svg height="50" width="150" viewbox="0 0 10 100"  style=" border:4px solid red" >
        <path d="M 0 0 L 50 0 L 80 60 L 50 60 L 0 60  " fill="white" />
        <image href="../../../../../assets/images/logo-t.png" x="0" y="0" height="50"  width="50"></image>
      </svg>
      </div> -->
    </div>

    <!-- Navigation links on the right -->
    <div class="nav-links">
      <a (click)="navigateToLogin()" class="nav-link" style="cursor: pointer;">Make a Claim</a>
      <a (click)="scrollToSection('footer')" class="nav-link" data-section="about" style="cursor: pointer;">About</a>
      <a (click)="scrollToSection('services')" class="nav-link" data-section="services"
        style="cursor: pointer;">Services</a>
    </div>
  </div>


  <div class="hero-content">
    <div class="hero-text">
      <h1 class="hero-title">
        <div class="title-line">
          <span class="typing-text" data-text="Pre-existing">Pre-existing</span>
        </div>
        <div class="title-line">
          <span class="typing-text" data-text="Medical">Medical</span>
          <span class="typing-text" data-text="Conditions">Conditions</span>
        </div>
        <div class="title-line">
          <span class="typing-text" data-text="Life">Life</span>
        </div>
        <div class="title-line highlight-line">
          <span class="typing-text" data-text="Insurance">Insurance</span>
          <div class="gif-container">
            <img src="../../../../../assets/gifs/Honest.gif" alt="Medical Insurance" width="60" height="60">
          </div>
        </div>
      </h1>

      <!-- Action buttons below the heading -->
      <div class="hero-actions">
        <button class="secondaryBtn" (click)="navigateToLogin()">Adviser Login</button>
        <button class="primaryBtn" (click)="navigateToLogin()">Customer Login</button>
      </div>
    </div>

    <!-- Animated Particles -->
    <div class="particles-container">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
      <div class="particle particle-5"></div>
      <div class="particle particle-6"></div>
      <div class="particle particle-7"></div>
      <div class="particle particle-8"></div>
      <div class="particle particle-9"></div>
      <div class="particle particle-10"></div>
    </div>

    <!-- Floating Chips -->
    <div class="floating-chips-container">
      <div class="floating-chip chip-1">
        <div class="chip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <path fill="#0075C9"
              d="M3 20V7h6V4h6v3h6v13zm7-13h4V5h-4zm10 7.5h-6V16h-4v-1.5H4V19h16zm-9 .5h2v-2h-2zm-7-1.5h6V12h4v1.5h6V8H4zm8 .5"
              stroke-width="0.5" stroke="#0075C9" />
          </svg>
        </div>
        <div class="chip-text">Working with a leading UK insurer</div>
      </div>
      <div class="floating-chip chip-2">
        <div class="chip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <path fill="#0075C9"
              d="M11.77 20v-1H19v-7.446q0-2.81-2.066-4.693Q14.867 4.977 12 4.977T7.066 6.861T5 11.554v5.696H3v-4.706h1l.017-1.224q.046-1.57.709-2.905T6.47 6.092t2.515-1.54T12 4t3.013.552q1.428.552 2.513 1.538q1.085.985 1.744 2.32q.66 1.334.712 2.895l.017 1.24h1v4.705h-1V20zm-2.385-6.461q-.31 0-.54-.21t-.23-.52t.23-.531t.54-.22q.31 0 .539.215q.23.216.23.535q0 .31-.23.52t-.54.21m5.232 0q-.31 0-.54-.21t-.23-.52t.23-.53t.54-.22t.539.215t.23.535q0 .31-.23.52t-.54.21M6.718 11.95q-.136-2.246 1.447-3.829q1.582-1.583 3.887-1.583q1.935 0 3.43 1.163t1.827 3.055q-1.987-.025-3.688-1.014t-2.61-2.75q-.362 1.731-1.505 3.034q-1.144 1.303-2.788 1.924"
              stroke-width="0.5" stroke="#0075C9" />
          </svg></div>
        <div class="chip-text">HPS Life supports adviser firms</div>
      </div>
      <div class="floating-chip chip-3">
        <div class="chip-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="-2 -2 24 24">
            <path fill="#0075C9"
              d="M7 12.917v.583a4.5 4.5 0 1 0 9 0v-1.67a3.001 3.001 0 1 1 2 0v1.67a6.5 6.5 0 1 1-13 0v-.583A6 6 0 0 1 0 7V2a2 2 0 0 1 2-2h1a1 1 0 1 1 0 2H2v5a4 4 0 1 0 8 0V2H9a1 1 0 1 1 0-2h1a2 2 0 0 1 2 2v5a6 6 0 0 1-5 5.917M17 10a1 1 0 1 0 0-2a1 1 0 0 0 0 2" />
          </svg>
        </div>
        <div class="chip-text">Pre-existing medical conditions</div>
      </div>
      <div class="floating-chip chip-4">
        <div class="chip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <path fill="#0075C9"
              d="M12 20.962q-3.014-.895-5.007-3.651T5 11.1V5.692l7-2.615l7 2.615V11.1q0 3.454-1.993 6.21T12 20.963m0-1.062q2.425-.75 4.05-2.962T17.95 12H12V4.144L6 6.375v5.156q0 .194.05.469H12z" />
          </svg></div>
        <div class="chip-text">Life insurance protection</div>
      </div>
      <div class="floating-chip chip-5">
        <div class="chip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <path fill="#0075C9"
              d="M10.758 15.192q.465.466 1.194.424q.729-.041 1.064-.524l5.253-7.323l-7.361 5.216q-.502.334-.559 1.038t.409 1.17M12 5q1.379 0 2.51.336q1.132.335 2.256 1.025l-.92.623q-.883-.482-1.828-.733T12 6Q8.675 6 6.337 8.338T4 14q0 1.05.288 2.075T5.1 18h13.8q.575-.95.838-1.975T20 13.9q0-.9-.232-1.894t-.734-1.852l.624-.92q.73 1.252 1.033 2.356T21 13.888q.006 1.29-.287 2.408q-.292 1.118-.91 2.254q-.12.2-.365.325T18.9 19H5.1q-.275 0-.51-.134q-.234-.135-.394-.393q-.496-.875-.846-1.974T3 14q0-1.844.7-3.481q.699-1.637 1.909-2.867T8.471 5.71T12 5m.04 6.96"
              stroke-width="0.5" stroke="#0075C9" />
          </svg></div>
        <div class="chip-text">Efficiently place higher risk cases</div>
      </div>
      <div class="floating-chip chip-6">
        <div class="chip-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <path fill="#0075C9"
              d="M16 17.096v-1h3.33l-6.026-5.938l-4 4L3 7.804l.708-.708l5.596 5.596l4-4L20 15.39v-3.293h1v5z" />
          </svg></div>
        <div class="chip-text">At competitive premiums</div>
      </div>
    </div>

  </div>
</section>